import { defineAsyncComponent } from '../compat/vueCompat';
import type { MovementRequest } from '../pages/folders/movement';
import type { FolderMoveWaitDialogRequest } from './folderMoveWaitDialogRequest';
import { requestDialog } from './requestDialog';

const MoveFolderContentDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/MoveFolderContentDialog.vue'));

export function showFolderMoveWaitDialog(movementRequests: MovementRequest[]) {
  const req: FolderMoveWaitDialogRequest = {
    movementRequests,
  };
  requestDialog(req, MoveFolderContentDialog);
}
